module.exports = __webpack_public_path__ + "img/SpeedCase.e5d45480.png";